//--- ARQUIVO ATUALIZADO: DasView.js (Com Modal Integrado) ---
import React, { useState, useEffect } from 'react';
import { ExternalLinkIcon } from './Icons.js';
import { DasGuideModal } from './DasGuideModal.js';
// REMOVIDO: import { DasPaymentModal } from './DasPaymentModal.js';

// Adiciona 'accounts' como prop
export const DasView = ({ dasPayments, onUpdateStatus, meiInfo, showNotification, accounts }) => {
    // Estado do Modal de Pagamento agora inclui os dados do formulário
    const [paymentModalInfo, setPaymentModalInfo] = useState({
        isOpen: false,
        month: null,
        paymentDate: new Date().toISOString().split('T')[0],
        lateFee: '',
        selectedAccountId: ''
    });
    const [showGuideModal, setShowGuideModal] = useState(false);
    const currentYear = new Date().getFullYear();
    const months = [ "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro" ];

    const openingDate = meiInfo?.dataAbertura ? new Date(meiInfo.dataAbertura + 'T00:00:00') : null;
    const openingYear = openingDate?.getFullYear();
    const openingMonth = openingDate?.getMonth(); // 0 para Janeiro

    const displayableMonths = (openingYear === currentYear && openingMonth !== undefined)
        ? months.slice(openingMonth)
        : months;

    const handleAction = (month, currentStatus) => {
        if (currentStatus === 'pendente') {
            if (!accounts || accounts.length === 0) {
                 showNotification("Cadastre uma conta financeira primeiro (Ex: Caixa) no menu 'Contas'.", "info");
                 return;
            }
            // Abre o modal e reseta os campos para o padrão
            setPaymentModalInfo({
                isOpen: true,
                month: month,
                paymentDate: new Date().toISOString().split('T')[0], // Data de hoje
                lateFee: '', // Limpa multa/juros
                selectedAccountId: accounts[0]?.id || '' // Seleciona a primeira conta ou vazio
            });
        } else { // Revertendo para pendente
            if (window.confirm(`Tem certeza que deseja reverter o pagamento do DAS de ${month}? A transação de despesa associada será excluída.`)) {
                onUpdateStatus(month.toLowerCase(), { status: 'pago' }); // Passa 'pago' para indicar reversão
            }
        }
    };

    // Função chamada ao confirmar o modal de pagamento
    const handleConfirmPayment = () => {
        const { month, paymentDate, lateFee, selectedAccountId } = paymentModalInfo;
        // Validação
        if (!selectedAccountId) {
            showNotification("Por favor, selecione a conta de onde o pagamento foi feito.", "error");
            return;
        }
        if (!paymentDate) {
             showNotification("Por favor, selecione a data do pagamento.", "error");
             return;
        }

        // Chama a função do App.js com todos os detalhes
        onUpdateStatus(month.toLowerCase(), {
            status: 'pendente', // Indica que é para marcar como pago
            paymentDate,
            lateFee: parseFloat(lateFee) || 0,
            accountId: selectedAccountId
        });

        // Fecha o modal
        setPaymentModalInfo({ isOpen: false, month: null, paymentDate: '', lateFee: '', selectedAccountId: '' });
    };

    // Função para fechar o modal
    const handleCancelPayment = () => {
         setPaymentModalInfo({ isOpen: false, month: null, paymentDate: '', lateFee: '', selectedAccountId: '' });
    };

    // Funções para atualizar o estado do modal interno
    const handleModalChange = (e) => {
        const { name, value } = e.target;
        setPaymentModalInfo(prev => ({ ...prev, [name]: value }));
    };


    const handleGenerateTicket = () => {
        if (meiInfo?.cnpj) {
            const justNumbersCnpj = meiInfo.cnpj.replace(/[^\d]/g, '');
            navigator.clipboard.writeText(justNumbersCnpj)
                .then(() => showNotification("CNPJ copiado!", "success"))
                .catch(() => showNotification("Erro ao copiar CNPJ.", "error"));
            setShowGuideModal(true);
        } else {
            showNotification("CNPJ não encontrado nas configurações.", "error");
        }
    };

    const handleConfirmGuide = () => {
        window.open('https://www8.receita.fazenda.gov.br/SimplesNacional/Aplicacoes/ATSPO/pgmei.app/Identificacao', '_blank');
        setShowGuideModal(false);
    };

    const safeDasPayments = dasPayments || {};

    return (
        <>
            <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-200 mb-6">Controle de Pagamento DAS - {currentYear}</h2>
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow">
                <ul className="space-y-4">
                    {displayableMonths.map((month) => {
                        const monthKey = month.toLowerCase();
                        const status = safeDasPayments[monthKey]?.status || 'pendente';
                        const isPaid = status === 'pago';

                        return (
                            <li key={month} className="flex items-center justify-between p-4 rounded-md bg-gray-50 dark:bg-gray-700/50 flex-wrap sm:flex-nowrap gap-4">
                                <div className="flex items-center flex-grow">
                                    <span className="w-24 flex-shrink-0 font-medium text-gray-700 dark:text-gray-300">{month}</span>
                                    <span className={`ml-4 px-2.5 py-1 text-xs font-semibold rounded-full ${isPaid ? 'bg-green-100 text-green-800 dark:bg-green-900/50 dark:text-green-300' : 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/50 dark:text-yellow-300'}`}>
                                        {isPaid ? 'Pago' : 'Pendente'}
                                    </span>
                                </div>
                                <div className="flex items-center space-x-3 flex-shrink-0 w-full sm:w-auto justify-end">
                                    {isPaid ? (
                                        <button onClick={() => handleAction(month, status)} className="inline-flex justify-center w-full sm:w-36 px-4 py-1.5 text-sm font-semibold rounded-md transition-colors bg-gray-200 dark:bg-gray-600 text-gray-800 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-500">
                                            Reverter
                                        </button>
                                    ) : (
                                        <>
                                            <button onClick={handleGenerateTicket} className="inline-flex items-center justify-center w-1/2 sm:w-36 px-4 py-1.5 text-sm font-semibold rounded-md transition-colors bg-gray-600 text-white hover:bg-gray-700">
                                                Gerar Guia <ExternalLinkIcon />
                                            </button>
                                            <button onClick={() => handleAction(month, status)} className="inline-flex justify-center w-1/2 sm:w-36 px-4 py-1.5 text-sm font-semibold rounded-md transition-colors bg-blue-600 text-white hover:bg-blue-700">
                                                Marcar Pago
                                            </button>
                                        </>
                                    )}
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </div>

            {/* --- Modal de Pagamento Integrado --- */}
            {paymentModalInfo.isOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
                    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-md">
                        <div className="p-6">
                            <h3 className="text-xl font-bold dark:text-gray-200 mb-4">Confirmar Pagamento do DAS - {paymentModalInfo.month}</h3>
                            <div className="space-y-4">
                                {/* Campo Seleção de Conta */}
                                <div>
                                    <label htmlFor="selectedAccountId" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Conta de Pagamento *</label>
                                    <select
                                        id="selectedAccountId"
                                        name="selectedAccountId" // Nome corresponde ao estado
                                        value={paymentModalInfo.selectedAccountId}
                                        onChange={handleModalChange} // Usa o handler genérico
                                        required
                                        className="mt-1 block w-full form-select dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                                    >
                                        <option value="" disabled>Selecione a conta...</option>
                                        {Array.isArray(accounts) && accounts.map(acc => (
                                            <option key={acc.id} value={acc.id}>{acc.name}</option>
                                        ))}
                                    </select>
                                </div>
                                {/* Fim do Campo Conta */}
                                <div>
                                    <label htmlFor="paymentDate" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Data do Pagamento</label>
                                    <input
                                        type="date"
                                        id="paymentDate"
                                        name="paymentDate" // Nome corresponde ao estado
                                        value={paymentModalInfo.paymentDate}
                                        onChange={handleModalChange} // Usa o handler genérico
                                        required
                                        className="mt-1 block w-full form-input dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                                    />
                                </div>
                                <div>
                                    <label htmlFor="lateFee" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Multa / Juros (Opcional, R$)</label>
                                    <input
                                        type="number"
                                        id="lateFee"
                                        name="lateFee" // Nome corresponde ao estado
                                        step="0.01"
                                        value={paymentModalInfo.lateFee}
                                        onChange={handleModalChange} // Usa o handler genérico
                                        placeholder="Ex: 3,50"
                                        className="mt-1 block w-full form-input dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="bg-gray-50 dark:bg-gray-700/50 px-6 py-4 flex justify-end space-x-4 rounded-b-lg">
                            <button onClick={handleCancelPayment} className="px-4 py-2 bg-gray-200 dark:bg-gray-600 dark:text-gray-200 rounded-md">Cancelar</button>
                            <button onClick={handleConfirmPayment} className="px-4 py-2 bg-blue-600 text-white rounded-md">Confirmar Pagamento</button>
                        </div>
                    </div>
                </div>
            )}
            {/* --- Fim do Modal Integrado --- */}


            {showGuideModal && <DasGuideModal onConfirm={handleConfirmGuide} onCancel={() => setShowGuideModal(false)} />}
        </>
    );
};